import { FC, useMemo } from 'react';
import { MaterialStateEnum, useMeshMaterialStore } from './meshMaterialStore';
import { CanvasControlButtonGroup } from '../CanvasControls/CanvasControlButtonGroup';
import { useCompareStore } from '../CompareControls/useCompareStore';

export const MaterialControls: FC = () => {
  const { materialState, setMaterialState } = useMeshMaterialStore();
  const { leftScan } = useCompareStore();

  const textureEnabled = useMemo(() => {
    return Boolean(leftScan?.textures_enabled);
  }, [leftScan]);

  if (!textureEnabled) {
    return null;
  }

  return (
    <CanvasControlButtonGroup
      title='Material'
      value={materialState}
      onChange={(value) => setMaterialState(value as MaterialStateEnum)}
      options={[
        { value: MaterialStateEnum.Texture, label: 'Texture' },
        { value: MaterialStateEnum.Xray, label: 'Transparent' },
      ]}
    />
  );
};
